export default "__VITE_ASSET__BSvFB$HC__"